import { Injectable, Injector } from '@angular/core';
import { User, UserObject } from '../../../bayadic-shared-models/classes/user/User';
import { Platform } from '@ionic/angular';
import { DatabaseManagerProvider } from '../../storage-manager/database-manager';
import { LoggerService } from '../../../app/services/logger.service';
@Injectable()
export class AvatarDatabaseManagerProvider extends DatabaseManagerProvider {

  constructor(   
    public injector : Injector,
    public platform : Platform,
    public logger: LoggerService
  ) {
      super(injector, logger);

      this.init().then(()=>{
        this.createUsersDataTable();
     });
  }
  async getUserByUserID(user : User) : Promise<User>{
    return new User({} as UserObject)
  }
  init() : Promise<any> {
    return new Promise((resolve,reject)=>{
        if(this.databaseObj != undefined)
            resolve(this.databaseObj);
        else {
          super.init().then(databaseObj=>{
            resolve(databaseObj);
          });
        }
    });
  }
  createUsersDataTable(){
    this.databaseObj.executeSql('create table  IF NOT EXISTS usersdata \n\
    (userID  VARCHAR(32),email VARCHAR(32) UNIQUE,name VARCHAR(32),familyName VARCHAR(32))', [])
    .then(() => { 
        this.logger.debug('Executed SQLL');
    })
    .catch(e => {
      this.logger.debug(e)

    });
  }
  save(user : User){
    let sqlString = 'INSERT OR IGNORE INTO usersdata (userID,email,name,familyName) VALUES ("'+
    user.userID+'","'+
    user.email+'","'+
    user.name+'","'+
    user.familyName+'")';
    this.databaseObj.executeSql(sqlString).then(
      result=>{
          this.logger.debug("user has beend saved in usersdata successfully");
      })
      .catch( e=>{
        this.logger.debug(" there was  an error adding usersdata to database",e);
      })
  }

}
